// extracted by mini-css-extract-plugin
export default {"layout":"Browse_layout__2MnlS","main":"Browse_main__VP23Z","rail":"Browse_rail__axSsT"};